// extracted by mini-css-extract-plugin
export default {"login":"Login_login__-STTZ"};